var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#restore_svg__clip0_860_1380)",
    fill: "#3A92E5"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7H3v7c0 .552.449 1 1.001 1H10C10.55 15 11 14.552 11 14V7zm2-2v10.5c0 .95-.68 1.71-1.51 1.71H2.51c-.83 0-1.51-.77-1.51-1.71V5h12zM9.15.5V2h4.31c.14 0 .28.05.38.15.1.09.16.22.16.35v1.04c0 .3-.23.46-.51.46H.54C.21 4 0 3.76 0 3.5v-1c0-.28.24-.5.54-.5h4.31V.5c0-.28.24-.5.54-.5h3.23c.14 0 .28.05.38.15.1.09.16.22.16.35h-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55 10.45h-2v-2A.553.553 0 007 7.9a.553.553 0 00-.55.55v2h-2a.553.553 0 00-.55.55c0 .301.249.55.55.55h2v2c0 .301.249.55.55.55.301 0 .55-.249.55-.55v-2h2c.301 0 .55-.249.55-.55a.553.553 0 00-.55-.55z",
    stroke: "#3A92E5",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "restore_svg__clip0_860_1380"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v18H0z"
  })))));
}
export default SvgRestore;